import React from "react";
import { Check } from "lucide-react";
import { whyChoose, doctors } from "../mock/data";

export default function WhyChoose() {
  return (
    <section className="relative py-24 md:py-28 bg-[#0e2b2b] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full bg-[#14a68e]/25 blur-3xl" />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-6">
          <div className="text-[12px] tracking-[0.22em] uppercase text-[#5eead4] font-semibold">Why choose</div>
          <h2 className="mt-4 font-serif-display text-[42px] md:text-[62px] leading-[1.05]">
            Dr. Khurana&rsquo;s Clinic?
          </h2>
          <p className="mt-5 text-[15px] md:text-[16px] text-white/70 max-w-[520px] leading-relaxed">
            A calm dental space with modern tools, honest guidance, and care that is planned around your comfort.
          </p>

          <ul className="mt-10 grid sm:grid-cols-2 gap-6">
            {whyChoose.map((w) => (
              <li key={w.title} className="flex gap-4">
                <span className="mt-1 w-8 h-8 shrink-0 rounded-full bg-[#14a68e] text-white flex items-center justify-center"><Check size={16} /></span>
                <div>
                  <div className="font-serif-display text-[22px] leading-tight">{w.title}</div>
                  <div className="text-white/60 text-[14px] mt-1">{w.desc}</div>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-12 flex items-center gap-10">
            <div>
              <div className="font-serif-display text-[38px] leading-none">5,000<span className="text-[#5eead4]">+</span></div>
              <div className="text-[11px] tracking-[0.22em] uppercase text-white/60 mt-1">Happy Patients</div>
            </div>
            <div className="w-px h-14 bg-white/15" />
            <div>
              <div className="font-serif-display text-[38px] leading-none">100<span className="text-[#5eead4]">%</span></div>
              <div className="text-[11px] tracking-[0.22em] uppercase text-white/60 mt-1">Pain-Free</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative aspect-[4/5] rounded-[36px] overflow-hidden bg-gradient-to-br from-[#0a1f1f] to-[#0e2b2b]">
            <img src="/images/doctors/dr-anshu-why-choose.webp" alt="Dr. Anshu Singh at Dr. Khurana&apos;s Dental &amp; Aesthetic Clinic" className="w-full h-full object-cover brightness-110 contrast-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0e2b2b]/85 via-[#0e2b2b]/25 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
              <div className="font-serif-display text-[24px] text-white">{doctors[1].name}</div>
              <div className="text-[11px] tracking-[0.18em] uppercase text-white/80 mt-1">Co-Director · BDS (Gold Medalist), FMC · Vice President, IFAD</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
